import { Check } from 'lucide-react';
import { m } from 'framer-motion';
import PropTypes from 'prop-types';
import React from 'react';

const TerminalStepper = ({ step, terminalMode, isInNavbar = false }) => {
    const steps = [
        { id: 1, label: 'Selection' },
        { id: 2, label: 'Review' },
        { id: 3, label: 'Authorize' }
    ];
    const isReplenishing = terminalMode === 'REPLENISHMENT';
    const activeColor = isReplenishing ? 'emerald' : 'amber';

    return (
        <div className={`flex items-center justify-center w-full ${isInNavbar ? 'py-0' : 'py-2'}`}>
            <div className="flex items-center gap-2">
                {steps.map((s, idx) => (
                    <React.Fragment key={s.id}>
                        {/* STEP ITEM */}
                        <div className="flex items-center gap-3">
                            <m.div 
                                initial={false}
                                animate={{ 
                                    scale: step === s.id ? 1.1 : 1,
                                    opacity: step >= s.id ? 1 : 0.4 
                                }}
                                className="relative flex items-center justify-center"
                            >
                                {/* Active Glow */}
                                {step === s.id && (
                                    <m.div 
                                        layoutId="stepGlow"
                                        className={`absolute inset-0 rounded-full blur-md bg-${activeColor}-500/40`}
                                    />
                                )}
                                
                            <div className={`
                                    relative w-7 h-7 rounded-full flex items-center justify-center text-[10px] font-black transition-all duration-500 border-2
                                    ${step === s.id 
                                        ? `bg-${activeColor}-500 border-${activeColor}-500 text-black shadow-lg shadow-${activeColor}-500/20` 
                                        : (step > s.id 
                                            ? 'bg-slate-900 border-slate-900 text-white' 
                                            : (isInNavbar ? 'bg-white/5 border-white/20 text-white/40' : 'bg-white border-slate-200 text-slate-400'))}
                                `}>
                                    {step > s.id ? <Check size={14} strokeWidth={4} /> : s.id}
                                </div>
                            </m.div>

                            <span className={`text-[9px] font-black uppercase tracking-widest hidden sm:block ${step === s.id ? (isInNavbar ? 'text-white' : 'text-slate-900') : (isInNavbar ? 'text-white/40' : 'text-slate-400')}`}>
                                {s.label}
                            </span>
                        </div>

                        {/* CONNECTOR LINE */}
                        {idx < steps.length - 1 && (
                            <div className="w-12 h-[2px] bg-slate-100 mx-2 overflow-hidden rounded-full">
                                <m.div 
                                    initial={false}
                                    animate={{ width: step > s.id ? '100%' : '0%' }}
                                    className={`h-full bg-${activeColor}-500 transition-all duration-500`}
                                />
                            </div>
                        )}
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
};

TerminalStepper.propTypes = {
    step: PropTypes.number.isRequired,
    terminalMode: PropTypes.string,
    isInNavbar: PropTypes.bool
};

export default TerminalStepper;
